/*
 *   Copyright (c) 2021 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { SUBSCRIPTION_REDUCER } from "../constants/enums";

const defaultState: any = {
  subscriptionPermissions: [],
  addonPermissions: [],
  currentTermEndsAt: "",
  cardDetailsStatus: "Not Provided",
  fromZohoPaymetntsPage: false,
  subscription: {},
  subscriptionApiCompleted: false,
};

const initialState: any = {
  ...defaultState,
};

export default function (state = initialState, action: any): any {
  switch (action.type) {
    case SUBSCRIPTION_REDUCER.SET_SUBSCRIPTION_PERMISSIONS:
      return {
        ...state,
        subscriptionPermissions: action.payload,
      };
    case SUBSCRIPTION_REDUCER.SET_ADDON_PERMISSIONS:
      return {
        ...state,
        addonPermissions: action.payload,
      };
    case SUBSCRIPTION_REDUCER.SET_CURRENT_TERM_ENDS_AT:
      return {
        ...state,
        currentTermEndsAt: action.payload,
      };
    case SUBSCRIPTION_REDUCER.SET_CARD_DETAILS_STATUS:
      return {
        ...state,
        cardDetailsStatus: action.payload,
      };
    case SUBSCRIPTION_REDUCER.SET_FROM_ZOHO_PAYMENTS_PAGE:
      return {
        ...state,
        fromZohoPaymetntsPage: action.payload,
      };
    case SUBSCRIPTION_REDUCER.SET_SUBSCRIPTION_RES:
      return {
        ...state,
        subscriptionPermissions: action.subscriptionPermissions,
        addonPermissions: action.addonPermissions,
        currentTermEndsAt: action.currentTermEndsAt,
        cardDetailsStatus: action.cardDetailsStatus,
        subscription: action.subscription || {},
        subscriptionApiCompleted: action.subscriptionApiCompleted,
      };
    default:
      return state;
  }
}
